import axios from 'axios'

function errorBody(error: unknown): object | undefined {
  if (!axios.isAxiosError(error)) return undefined
  const data: unknown = error.response?.data
  return typeof data === 'object' && data !== null ? data : undefined
}

/** The backend's typed `errorCode` from an Axios error body, or undefined. getApiError drops it. */
export function apiErrorCode(error: unknown): string | undefined {
  const body = errorBody(error)
  return body !== undefined &&
    'errorCode' in body &&
    typeof body.errorCode === 'string'
    ? body.errorCode
    : undefined
}

/** The backend's `details` from an Axios error body (unvalidated), or undefined. */
export function apiErrorDetails(error: unknown): unknown {
  const body = errorBody(error)
  return body !== undefined && 'details' in body ? body.details : undefined
}
